// R503 (c): the till ring's sound, WebAudio only, ported from HOP's features/ring/ring-audio.ts
// (R503 (b)) with the same names: only the parts the ring uses (the context, the loudness and the
// ring). The till's R462 kitchen-done beep stays in lib/beep.ts. Each player swallows its own
// errors: a blocked or missing audio device must never break the till.

// The loudest gain the ring plays at (HOP's MAX_GAIN). `ring.loudness` 100 is this gain, 0 is silence.
export const MAX_GAIN = 0.3

export function createRingAudio(): AudioContext | null {
  try {
    const Ctx =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
    return Ctx ? new Ctx() : null
  } catch {
    return null
  }
}

// `ring.loudness` (a whole number, 0 to 100) as a gain from 0 to MAX_GAIN.
export function loudnessGain(loudness: number): number {
  if (!Number.isFinite(loudness)) return 0
  const clamped = Math.min(100, Math.max(0, loudness))
  return (MAX_GAIN * clamped) / 100
}

// The ring: three square pulses, 660 Hz / 990 Hz alternating, at the owner's loudness.
export function playRing(ctx: AudioContext, gainValue: number = MAX_GAIN): void {
  try {
    const PULSE_S = 0.25
    const GAP_S = 0.1
    const freqs = [660, 990, 660]
    const t0 = ctx.currentTime
    freqs.forEach((hz, i) => {
      const osc = ctx.createOscillator()
      const gain = ctx.createGain()
      osc.type = 'square'
      osc.frequency.value = hz
      gain.gain.value = gainValue
      osc.connect(gain)
      gain.connect(ctx.destination)
      const start = t0 + i * (PULSE_S + GAP_S)
      osc.start(start)
      osc.stop(start + PULSE_S)
    })
  } catch {
    // quiet by design
  }
}
